import React from 'react'
import { Field, useForm } from 'react-final-form'
import { gsColors } from '../../../styles/Variables'
import InputField from '../input-field'
import styled from '@emotion/styled'
import TextAreaField from '../textarea-field'
import AutoCompleteField from '../autocomplete-field'
import MultiSelectField from '../multi-select'
import SelectField from '../dropdown-field'
import CalendarField from '../calendar-field'
import { mq } from '../../../helpers'
import { useScrollToFirstError } from '../utils'

const OutOfZoneForm = ({ fieldRefs }) => {
  const form = useForm()
  useScrollToFirstError(form, fieldRefs)
  return (
    <OutOfZoneFormContainer>
      <div className='out-of-zone-form-inner'>
        <div className='detail-section'>
          <h2>Contact Details</h2>
          <div className='content'>
            <Field
              component={InputField}
              placeholder="First Name"
              name="First Name"
              ref={(el) => (fieldRefs.current['First Name'] = el)}
            />
            <Field
              component={InputField}
              placeholder="Last Name"
              name="Last Name"
              ref={(el) => (fieldRefs.current['Last Name'] = el)}
            />
            <Field
              component={InputField}
              placeholder="Phone Number"
              name="Phone Number"
              parse={(value) => value && value.replace(/[^\d+\-\s()]/g, '')}
              inputMode="tel"
              ref={(el) => (fieldRefs.current['Phone Number'] = el)}
            />
            <Field
              component={InputField}
              placeholder="Email"
              name="Email"
              ref={(el) => (fieldRefs.current['Email'] = el)}
            />
          </div>
        </div>

        <div className='out-of-zone-detail-section'>
          <MultiSelectField
            name="Services"
            placeholder="Services"
            options={['Hair', 'Makeup', 'Nails']}
            ref={(el) => (fieldRefs.current['Services'] = el)}
            boldTitle={true}
          />
          <MultiSelectField
            name="Type of Services"
            placeholder="Type of Services"
            options={['Full Glam', 'Express/Touch-Up', 'Children']}
            ref={(el) => (fieldRefs.current['Type of Services'] = el)}
            boldTitle={true}
          />
          <AutoCompleteField
            name="Address"
            placeholder="Address"
          />
          <div className="people-and-date-section">
            <SelectField
              name="Number of People"
              placeholder="Number of People Needing Services"
              options={[
                { value: '1', name: '1 Person' },
                { value: '2-4', name: '2-4 People' },
                { value: '5-9', name: '5-9 People' },
                { value: '10+', name: '10+ People' },
              ]}
            />
            <CalendarField
              name="Event Date"
              placeholder="Event Date"
              ref={(el) => (fieldRefs.current['Event Date'] = el)}
            />
          </div>
        </div>

        <div className="booking-notes-section">
          <h2>
            Booking Notes <span className="optional-tag">(Optional)</span>
          </h2>
          <Field
            name="Booking Notes"
            placeholder="Please add any additional event details."
            component={TextAreaField}
          />
        </div>

      </div>
    </OutOfZoneFormContainer>
  )
}

export default OutOfZoneForm

const OutOfZoneFormContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;

  ${mq('max', '768px')} {
    width: 100%;
  }

  h2 {
    font-size: 20px;
  }

  .out-of-zone-form-inner {
    max-width: 800px;
    width: 100%;
    margin: 80px 0 50px;
    display: flex;
    flex-direction: column;
    gap: 60px;

    ${mq('max', '800px')} {
      padding: 0 16px;
      margin: 40px 0 50px;
    }

    .detail-section {
      h2 {
        margin-bottom: 24px;
      }

      .content {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 32px;

        ${mq('max', '768px')} {
          grid-template-columns: 1fr;
        }

        div {
          margin: 0;
        }
      }
    }

    .out-of-zone-detail-section {
      h2 {
        margin-bottom: 24px;
      }

      .people-and-date-section {
        margin: 24px 0;
        display: flex;
        justify-content: space-evenly;
        gap: 32px;

        ${mq('max', '768px')} {
          flex-direction: column;
          margin-bottom: 0;
        }

        .calendar-button {
          height: 55px;
        }
      }

      .checkbox-container {
        margin-top: 24px;

        label {
          display: flex;
          padding-left: 0;

          p {
            ${mq('max', '768px')} {
              transform: translateY(4px);
              margin-left: 12px;
            }
          }
        }
      }
    }

    h2 {
      .optional-tag {
        font-weight: 400 !important;
        color: ${gsColors.meredithGrey};
        font-size: 16px;
      }
    }

    .booking-notes-section {
      display: flex;
      flex-direction: column;
      margin-top: -20px;
      gap: 24px;
    }
  }
`
